import React, { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ADM, GFE, GFO, GFE_CONSULTA, GFO_CONSULTA } from '~/constants/perfil';

import { UnidataTable, Modal } from '~/components';
import { number } from '~/helpers';
import {
  findOperacaoCotaDistribOrgao,
  recordFiltering,
} from '~/store/modules/operacaocotadistriborgao/actions';
import DetalheJustificativa from './DetalheJustificativa';
import { Visibility } from '@material-ui/icons';

function OperacaoCotaDistribOrgao() {
  const { profile } = useSelector((state) => state.user);

  const modalJusRef = useRef(null)

  const operacaocotadistriborgao = useSelector(
    (state) => state.operacaocotadistriborgao
  );

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      switch (profile.glousuariotipo) {
        case ADM:
        case GFE:
        case GFO:
        case GFE_CONSULTA:
        case GFO_CONSULTA:
          break;
        default:
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const header = useMemo(
    () => [
      {
        id: 'orga_codigo',
        label: 'Órgão',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'orga_nome',
        label: 'Descrição Órgão',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'prod_descricao',
        label: 'Produto',
        filter: {
          type: 'text',
        },
        align: 'left',
      },

      {
        id: 'coor_cota',
        label: 'Cota',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'coor_saldo',
        label: 'Saldo',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'coor_justificativa',
        label: 'Justificativa',
        formatted: (value) => value && value.length > 10 ? value.substring(0, 5) + '...' : value,
      },

    ],
    []
  );


  const buttons = useMemo(() => [
    {

      title: 'Visualizar Justificativa',
      action: (value) => modalJusRef.current.handleOpenModal({ data: value }),
      icon: <Visibility />,
    }

  ], [])

  const actionsModalObs = useMemo(() => [{
    label: 'Fechar',
    color: 'secondary',
    callback: () => modalJusRef.current.handleCloseModal(),
  }], [modalJusRef])

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="orga_codigo ASC"
        create={false}
        delete={false}
        update={false}
        title={'Visualizar Cota Órgão'}
        fixed
        header={header}
        find={findOperacaoCotaDistribOrgao}
        redux={operacaocotadistriborgao}
        read={recordFiltering}
        detach="orga_nome"
        keys={['orga_codigo']}
        view="VW_VISUALIZAR_ORGAO_COTA_SALDO"
        reportTitle="Visualizar Cota Órgão"
        actions={buttons}
      />

      <Modal
        ref={modalJusRef}
        component={DetalheJustificativa}
        title="Justificativa"
        maxWidth="sm"
        actions={actionsModalObs}
      />

    </>
  );
}

export default OperacaoCotaDistribOrgao;
